/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RazzaUpdateDTO
 */
export interface RazzaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof RazzaUpdateDTO
     */
    descrizione: string;
}

/**
 * Check if a given object implements the RazzaUpdateDTO interface.
 */
export function instanceOfRazzaUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function RazzaUpdateDTOFromJSON(json: any): RazzaUpdateDTO {
    return RazzaUpdateDTOFromJSONTyped(json, false);
}

export function RazzaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RazzaUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
    };
}

export function RazzaUpdateDTOToJSON(value?: RazzaUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
    };
}

